import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuditService, ActivityTypes } from '../../../../services/audit.service';

@Component({
  selector: 'app-research-portal-stats-total-access-data',
  templateUrl: './research-portal-stats-total-access-data.component.html',
  styleUrls: ['./research-portal-stats-total-access-data.component.scss']
})
export class ResearchPortalStatsTotalAccessDataComponent implements OnInit {
  totalAccessData: any;

  @Output() seriesClicked: EventEmitter<any> = new EventEmitter();
  constructor(private auditService: AuditService) {}

  ngOnInit() {
    this.getTotalAccessData();
  }

  async getTotalAccessData() {
    this.totalAccessData = await this.auditService.getTotalAccessData();
    this.totalAccessData = this.totalAccessData.map(item => {
      let activity = ActivityTypes.find(e => e.type === item.type);
      if (activity) {
        item.typeName = activity.name;
      }
      return item;
    });
  }

  onSeriesClick(e) {
    this.seriesClicked.emit(e.dataItem.typeName);
  }
}
